<template>
        <div class="col-12 col-md-6 mt-4" v-if="design !== 'homepage'">
            <div class="mt-2">
                <a
                    class="mb-3 directions-product-listing shop-product-card navigator-card bg-white p-3 rounded w-100 text-left"
                    :href="item.productUrl"
                    target="_blank"
                >
                    <div class="row w-100 directions-align-center">
                        <div class="col-12 col-lg-8">
                            <div class="row directions-align-center">
                                <div class="col-3 text-left mobile-shop-adverts-text">
                                    <img class="directions-flag" :alt="item.productName" width="50" height="auto"
                                         :src="item.countryFlag" />
                                </div>
                                <div class="col-9 text-left">
                                    <div class="text-quote mobile-shop-adverts-text" v-html="item.productName"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-4 mobile-shop-advert-text-hidden">
                            <div class="call-to-action-advert-container">
                                <strong class="d-block" v-html="$t('directions.orderNow')"></strong>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>


    <div class="col-12 col-md-6 mt-4" v-else-if="design === 'homepage'">
        <div class="mt-2">
            <a
                class="mb-3 directions-product-listing shop-product-card navigator-card bg-white p-3 rounded w-100 text-left homepageProduct"
                :href="item.productUrl"
                target="_blank"
            >
                <div class="row w-100 directions-align-center">
                    <div class="col-12 col-lg-8">
                        <div class="row directions-align-center">
                            <div class="col-3 text-left mobile-shop-adverts-text">
                                <img class="directions-flag" :alt="item.productName" width="50" height="auto"
                                     :src="item.countryFlag" />
                            </div>
                            <div class="col-9 text-left">
                                <div style="color: #000" class="mobile-shop-adverts-text" v-html="item.productName"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 mobile-shop-advert-text-hidden">
                        <div class="call-to-action-advert-container">
                            <strong style="color: #000" class="d-block" v-html="$t('directions.orderNow')"></strong>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        design: {
            type: String,
            required: false,
        },
    },
};
</script>

<style scoped>
.homepageProduct {
    border-radius: 10px;
    border: 1px solid #D2D2D7 !important;
    background: #F0F8F7 !important;
    color: #000 !important;
}
.homepageProduct:hover {
    background-color: var(--main-color) !important;
    border: 1px solid var(--main-color);
}
</style>
